import { Component, OnInit, SimpleChanges } from '@angular/core';
import { Router } from '@angular/router';
import { OfflineService } from 'src/app/offline/offline.service';
import { BaseSearchComponent } from 'src/app/system-common/base-search/base-search.component';
import { HeaderService } from 'src/app/system-common/services/header.service';
import { SettingService } from 'src/app/system-common/services/setting.service';
import { NotificationService } from '../services/notifications.service';
import { PageHeader } from 'src/app/models/common/page-header';
import { BreadCrumb } from 'src/app/models/common/bread-crumb';

@Component({
  selector: '',
  template: '',
})
export class BirthDayRemindersHandler extends BaseSearchComponent<NotificationService> implements OnInit {
  birthdayReminderResponseData;
  birthdayReminderInfo = [];

  constructor(
    public service: NotificationService,
    public headerService: HeaderService,
    public router: Router,
    public settingService: SettingService,
    public offlineService: OfflineService
  ) {
    super(service, router);
    // this.geBirthDayReminders();
  }

  ngOnInit() {
    super.ngOnInit();
    this.getBirthDayReminders();
  }

  ngOnChanges(changes: SimpleChanges) {
    super.ngOnChanges(changes);
    this.getBirthDayReminders();
  }

  protected getBreadCrumbList(): BreadCrumb[] {
    return [
      {
        id: 'Home',
        link: '/home',
      },
      {
        id: 'upcomingBirthdays',
      },
    ];
  }

  protected getPageHeader(): PageHeader {
    let header = new PageHeader();
    header.title = this.settingService.getLabelValue('upcomingBirthdays');
    return header;
  }

  // getBirthDayReminders() {
  //   this.birthdayReminderResponseData = [];
  //   this.service.getNotification('BIRTHDAY').subscribe(
  //     (body) => {
  //       let response = JSON.parse(JSON.stringify(body));
  //       Object.keys(response.data['BirthdayNotificationList']).forEach((month) => {
  //         this.birthdayReminderResponseData.push(month);
  //         this.birthdayReminderInfo.push(response.data['BirthdayNotificationList'][month]);
  //       });
  //     },
  //     (error) => {
  //       console.log('Error:', error);
  //       this.service.handleError(error);
  //     }
  //   );
  // }

  getBirthDayReminders() {
    this.birthdayReminderResponseData = [];
    this.birthdayReminderInfo = [];

    this.service.getNotification('BIRTHDAY').subscribe(
      (body) => {
        let response = JSON.parse(JSON.stringify(body));

        Object.keys(response.data['BirthdayNotificationList']).forEach((dateStr) => {
          // dateStr = "27/10/2028" (dd/MM/yyyy)
          let [day, month, year] = dateStr.split('/').map(Number);
          let properDate = new Date(year, month - 1, day); // convert to Date object

          this.birthdayReminderResponseData.push(properDate);
          this.birthdayReminderInfo.push(response.data['BirthdayNotificationList'][dateStr]);
        });
      },
      (error) => {
        console.log('Error:', error);
        this.service.handleError(error);
      }
    );
  }
}
